import AccountTreeIcon from '@mui/icons-material/AccountTree';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import {
  BreadcrumbsComponent,
  LinkItem,
} from '../../components/Breadcrumbs/Breadcrumbs';
import CustomTablePagination from '../../components/CustomTablePagination/CustomTablePagination';
import { DeleteBusinessRequestModal } from './components/DeleteBusinessRequestModal';
import { PreviewBusinessRequestModal } from './components/PreviewBusinessRequestModal';
import { TableRowComponent } from './components/TableRowComponent';
import styles from './styles.module.css';
import { Column } from './types';
import { useBusinessPage } from './useBusinessPage';

const columns: Column[] = [
  { name: 'email', label: 'Email', minWidth: 170 },
  { name: 'phoneNumber', label: 'Phone number', minWidth: 100 },
  {
    name: 'createdAt',
    label: 'Created at',
    minWidth: 170,
  },
  {
    name: 'selectedPlan',
    label: 'Selected plan',
    minWidth: 100,
  },
  {
    name: 'actions',
    label: 'Actions',
    minWidth: 100,
  },
];

const linkList: LinkItem[] = [
  {
    name: 'Projects',
    to: '/',
    icon: <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
  },
  {
    name: 'Choice',
    to: '/choice',
    icon: <AccountTreeIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
  },
  {
    name: 'Business',
    to: '',
    icon: <EmailIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
  },
];

export const BusinessPage = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const {
    businessRequests,
    metaData,
    page,
    quantity,
    order,
    setPage,
    setQuantity,
    setOrder,
    updateRequestAfterDelete,
  } = useBusinessPage();

  const onPageDelete = (mailId: string) => {
    setOpenModal(true);
    setDeleteId(mailId);
  };

  const onCloseModal = () => {
    setOpenModal(false);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setQuantity(+event.target.value);
    setPage(1);
  };

  return (
    <Container maxWidth="xl">
      <div className={styles.container}>
        <div className={styles.header}>
          <Typography variant="h2">Mails</Typography>
        </div>
        <BreadcrumbsComponent linkList={linkList} />
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.name}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        fontWeight: 'bolder',
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {businessRequests.map((row, index) => (
                  <TableRowComponent
                    row={row}
                    columns={columns}
                    onPageDelete={onPageDelete}
                    key={index}
                    onPreview={() => {
                      setOpenPreviewModal(true);
                      setSelectedItem(row);
                    }}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {metaData && (
            <CustomTablePagination
              count={metaData.pageCount}
              rowsPerPage={quantity}
              page={page - 1}
              onChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Paper>
      </div>
      <DeleteBusinessRequestModal
        open={openModal}
        onClose={onCloseModal}
        id={deleteId}
        updateMailsAfterDelete={updateRequestAfterDelete}
      />
      <PreviewBusinessRequestModal
        data={selectedItem}
        open={openPreviewModal}
        onClose={() => setOpenPreviewModal(false)}
      />
    </Container>
  );
};
